import ExpenseDate from "./ExpenseDate";
import Card from "../UI/Card";
import "./ExpenseItem.css";

function ExpenseItem(props) {

  function clickHandler() {
    props.onSaveDelID(props.id);
    console.log(props.id)
  };

  return (  
    <Card className="expense-item">
      <ExpenseDate date={props.date} />
      <div className="expense-item__description">
        <h2>{props.title}</h2>
        <div className="expense-item__price">{'$ ' + props.amount}</div>
        <div className="expense-item_actions">
          <button className='expense-item_delete' onClick={clickHandler}>Delete</button>
          <button className='expense-item_edit' >Edit</button>
        </div>
      </div>
    </Card>
  );
} 

export default ExpenseItem;
